export const contactConstants = {
  SEND_EMAIL_REQUEST: 'USERS_SEND_EMAIL_REQUEST',
  SEND_EMAIL_SUCCESS: 'USERS_SEND_EMAIL_SUCCESS',
  SEND_EMAIL_FAILURE: 'USERS_SEND_EMAIL_FAILURE',  
  SEND_EMAIL_RESET: 'USERS_SEND_EMAIL_RESET',  
};
